/** Seam for the order-creation task (shoppingCartOrderInit, payment gateway, redirect); intentionally a no-op until then. */
export async function startOrderPlaceholder(): Promise<void> {
  // no-op
}
